export const LevelToIcon: Record<string, string> = {
  info: 'circle-information',
  neutral: 'circle-checkmark',
  warn: 'triangle-exclamation',
  error: 'circle-exclamation',
  success: 'circle-checkmark',
}
